import React from 'react';
import { HyperdbForm } from '../../../../hyperdb';
import { Tabs, Tab } from 'react-bootstrap';
import { Form, PropertiesTab } from '../components';

class EditForm extends React.Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.handleClickCheckbox = this.handleClickCheckbox.bind(this);
    this.handleChangeSettings = this.handleChangeSettings.bind(this);
  }
  render() {
    if (this.props.objectData.type === 'output') {
      return (
        <Form
          objectData={ this.props.objectData }
          onChange={ this.handleChange }
          onClickCheckbox={ this.handleClickCheckbox }
          onChangeSettings={ this.handleChangeSettings }
        />
      );
    }
    return (
      <Tabs defaultActiveKey={1} id="channel-form">
        <Tab eventKey={1} title="Channel">
          <Form
            objectData={ this.props.objectData }
            onChange={ this.handleChange }
            onClickCheckbox={ this.handleClickCheckbox }
            onChangeSettings={ this.handleChangeSettings }
          />
        </Tab>
        <Tab eventKey={2} title="Properties">
          <PropertiesTab channelId={ this.props.objectData.id } { ...this.props } />
        </Tab>
      </Tabs>
    );
  }

  handleChange(attributeName, field) {
    let value = field.value;
    if (attributeName === 'type' && !value) value = 'input';
    if (attributeName === 'protocol' && !value) value = 'Domino';
    this.props.api.channel.updateEditedObject({ attributeName, value });
  }
  handleClickCheckbox(attributeName) {
    const checked = !this.props.objectData[attributeName];
    this.handleChange(attributeName, { value: checked });
  }
  handleChangeSettings(attributeName, field) {
    const settings = { ...this.props.objectData.settings || {} };
    settings[attributeName] = field.value;
    this.handleChange('settings', { value: settings });
  }
}

EditForm.propTypes = {
  api: React.PropTypes.object,
  objectData: React.PropTypes.object,
};

export default HyperdbForm(EditForm, {
  namespace: 'channel',
  mountedUrl: '/channels',
  titleEdit: 'Edit channel',
  displayName: (object) => object.name,
  backUrl: (props) => `/channels`,
});



// WEBPACK FOOTER //
// ./src/frontend/modules/inventory/channel/containers/EditForm.jsx